import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'Mint Jadu Hoverboards',
  description:
    '5555 Hoverboards you can use in the Metaverse and AR. Minting for 0.222 ETH',
  image: '%PUBLIC_URL%/logo192.png',
}

export const customMeta: { [key: string]: PageMeta } = {
  '/': {
    title: 'Mint Jadu Hoverboards',
  }
}
